import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { useHistoryCustomBack } from 'weblite-router'
import { CompatibilityWarningLayout } from '$common/compatibility-warning-layout'
import { t } from '$i18n'
import {
  // #moghavemat,
  MADRESE_TAALI_MOGHAVEMAT_ROOMID,
} from '$logic/profile'
import { useHall } from '$logic/hall/react-hook'
import { HallAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { nothing } from '$func/utils'
import { openProfileCompletion } from '$logic/router'
import { ArrowIOSIcon } from '$common/icons'

// #moghavemat
export function ProfileCompletionWarning({ isOpen }: { isOpen: boolean }) {
  const { entity: hall } = useHall(MADRESE_TAALI_MOGHAVEMAT_ROOMID)
  useHistoryCustomBack(() => {}, [])
  return (
    <CompatibilityWarningLayout
      isOpen={isOpen}
      icon={
        <HallAvatar
          roomId={MADRESE_TAALI_MOGHAVEMAT_ROOMID}
          size={AvatarSize._3XL}
        />
      }
      title={t('completeProfileModal.title')(hall?.name)}
      description={t('completeProfileModal.description')(hall?.name)}
      onClose={nothing}
      hideIconContainer
      onClick={() => {
        closeCurrentModal()
        openProfileCompletion()
      }}
      actionText={t('common.resume')}
      endIcon={<ArrowIOSIcon sx={{ color: 'neutral900' }} />}
    />
  )
}
